module.exports = __webpack_public_path__ + "8005c78e66af6c87721cfde5ab9d2a95.svg";